import { render, staticRenderFns } from "./part3.vue?vue&type=template&id=4f1c74bb&"
import script from "./part3.vue?vue&type=script&lang=js&"
export * from "./part3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports